module.exports = __webpack_public_path__ + "img/image_8.92dcad32.jpg";